
<div id="animate-area" style="display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #f5f5f5;">
  <div class="container-login100">
    <div class="limiter">

      <div class="card custom-card-color p-4 col-12 col-md-8 col-lg-6" style="border-radius: 15px; z-index: 1; max-width: 800px;">
        <div class="card bg-white" style="border-radius: 15px;">
          <div class="card-header text-center bg-white py-4">
            <i class="bi bi-envelope-fill text-primary fs-1"></i>
            <h4 class="mt-3 fw-bold" style="font-size: 24px;">Debes cambiar tu Contraseña de inicio de sesión</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
              <div class="mb-3">
                <label for="anteriorPassword" class="form-label" style="font-weight: bold; font-size: 16px;">Contraseña anterior</label>
                <div class="input-group">
                  <input required
                    [type]="hide1 ? 'password' : 'text'"
                    id="anteriorPassword"
                    class="form-control"
                    formControlName="anteriorPassword"
                    placeholder="Ingresa tu contraseña anterior"
                    style="background-color: rgb(241, 241, 241); font-size: 16px;">
                  <button type="button" mat-icon-button (click)="toggleHide1()" [attr.aria-label]="'Hide anteriorPassword'" [attr.aria-pressed]="hide1">
                    <mat-icon>{{ hide1 ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <label for="newPassword" class="form-label" style="font-weight: bold; font-size: 16px;">Contraseña nueva</label>
                <div class="input-group">
                  <input required
                    [type]="hide2 ? 'password' : 'text'"
                    id="newPassword"
                    class="form-control"
                    formControlName="newPassword"
                    placeholder="Ingresa tu nueva contraseña"
                    style="background-color: rgb(241, 241, 241); font-size: 16px;">
                  <button type="button" mat-icon-button (click)="toggleHide2()" [attr.aria-label]="'Hide newPassword'" [attr.aria-pressed]="hide2">
                    <mat-icon>{{ hide2 ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div class="mb-3">
                <label for="repeatPassword" class="form-label" style="font-weight: bold; font-size: 16px;">Repetir contraseña nueva</label>
                <div class="input-group">
                  <input required
                    [type]="hide3 ? 'password' : 'text'"
                    id="repeatPassword"
                    class="form-control"
                    formControlName="repeatPassword"
                    placeholder="Repite tu nueva contraseña"
                    style="background-color: rgb(241, 241, 241); font-size: 16px;">
                  <button type="button" mat-icon-button (click)="toggleHide3()" [attr.aria-label]="'Hide repeatPassword'" [attr.aria-pressed]="hide3">
                    <mat-icon>{{ hide3 ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </div>
                <div *ngIf="passwordsDoNotMatch" class="text-danger mt-2" style="font-size: 14px;">
                  Las contraseñas no coinciden.
                </div>
              </div>
            </form>
          </div>
          <div class="d-flex justify-content-end w-100">
            <button style="margin-right: 5px; font-size: 16px;" class="btn btn-secondary me-2" (click)="cerrarSesion()">Salir</button>
            <button class="btn btn-primary" style="font-size: 18px;" type="button" (click)="onSubmit()">
              Cambiar Contraseña
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


  <ng-template #Cambio let-groupKey="groupKey" let-modal="modal">
  <div class="table-responsive">
  <div class="modal-header" style="display: flex; align-items: center; position: relative;">
      <h5 
          class="modal-title" 
          style="font-weight: bold; font-size: 14px; margin: 0; text-align: center; width: 100%;">
          Cambio de contraseña exitoso
      </h5>
  </div>
  <div class="modal-body" >
     Por favor, haz clic en "Ingresar" para entrar con su nueva contraseña.
  </div>
  <div class="modal-footer">
    <button mat-button mat-dialog-close (click)="cerrarSesion1()" class="btn" style="background-color: #007bff; color: white; border: none;">
      Ingresar
    </button>
  </div>
  </div>
  </ng-template>
